module.exports = __webpack_public_path__ + "img/client22.14a85361.svg";